import React from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
interface HeroSectionProps {
  onBookConsultation?: () => void;
}
export function HeroSection({
  onBookConsultation
}: HeroSectionProps) {
  return <section className="relative min-h-[90vh] flex flex-col justify-center pt-20 overflow-hidden bg-hero-parallax" data-id="element-115">
      <div className="container mx-auto px-4 md:px-8 relative z-10 flex flex-col items-center text-center max-w-4xl" data-id="element-116">
        <span className="text-sage font-sans font-bold uppercase tracking-[0.2em] text-xs md:text-sm mb-6" data-id="element-117">
          Halo Skin Resurfacing · Be Clinical San Ramon
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-foreground leading-[1.1] mb-8" data-id="element-118">
          This Is What Your Skin Looks Like When It Remembers Itself
        </h1>

        <p className="text-lg md:text-xl text-foreground/80 font-sans max-w-2xl mb-12 leading-relaxed" data-id="element-119">
          Halo uses dual-wavelength laser technology to trigger your skin's own
          renewal process — fading years of damage and revealing the luminous
          skin that was always underneath.
        </p>

        <div className="w-full md:w-auto flex flex-col items-center space-y-6" data-id="element-120">
          <Button size="full" className="md:px-12 md:py-5 md:text-base" onClick={onBookConsultation} data-id="element-121">
            Book Your Free Consultation
          </Button>

          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-xs sm:text-sm font-sans text-foreground/70" data-id="element-122">
            <div className="flex text-gold" data-id="element-123">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" className="mr-0.5 sm:w-4 sm:h-4" data-id="element-124" />)}
            </div>
            <span className="tracking-wide text-center" data-id="element-125">
              250+ Reviews · 4.9 Stars · San Ramon, CA
            </span>
          </div>
        </div>
      </div>
    </section>;
}